import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import PostDetails from '../PostDetails';
import { Close } from '@material-ui/icons';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import { Switch, Grid, CircularProgress, Typography, Divider, AppBar, Toolbar, IconButton } from '@material-ui/core/';
import { Context } from '../../Context';

const styles = (theme) => ({
	closeButton: {
		marginLeft: -20
	},
	typography: {
		marginBottom: 10
	},
	wrapper: {
		position: 'relative'
	},
	buttonProgress: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		marginTop: -9,
		marginLeft: -9
	},
	submit: {
		marginTop: theme.spacing.unit * 2,
		marginBottom: theme.spacing.unit
	},
	dialogPaper: {
		minHeight: '60vh',
		maxHeight: '100vh',
	},
});

class AcceptPostsDialog extends React.Component {
	handleClose = () => {
		this.props.handleDialogClose();
	};

	handleAccept = event => {
		this.context.actions.approveAdvertiserCampaignPosts(this.props.campaign._id, (err) => {
			if (err) {
				return alert(err);
			}
			this.handleClose();
		});
	}

	toggleAutoPilot = event => {
		this.props.handleChange('autopilot');
	}

	render() {
		const { fullScreen } = this.props;
		const { classes } = this.props;

		return (
			<div>
				<Dialog
					fullScreen={fullScreen}
					fullWidth={true}
					open={this.props.open}
					onClose={this.handleClose}
					scroll='paper'
					aria-labelledby="Accept campaign posts"
					maxWidth='xl'
					classes={{ paper: classes.dialogPaper }}
				>
					<AppBar position='static'>
						<Toolbar>
							<IconButton color="inherit" onClick={this.handleClose} aria-label="Close" className={classes.closeButton}>
								<Close />
							</IconButton>
							<Typography variant="h6" color="inherit" className={classes.flex}>
								{this.props.campaign.name} - Approve Creators
              				</Typography>
						</Toolbar>
					</AppBar>
					<Divider style={{ marginBottom: 20 }} />
					<DialogContent>
						<Grid container spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h5" color="inherit" className={classes.typography}>
									These creators want to promote your brand. Take a look and accept the selection!
              					</Typography>
								<Typography variant="body1" color="inherit" className={classes.typography}>
									The selection of creators have been curated and vetted by Vimma from all the people that have shown interested in the campaign. Accept them to start the campaign!
              					</Typography>
							</Grid>
							<Grid item xs={12}>
								<Grid container spacing={2}>
									{this.props.actionRequiredPosts.map((p) => (
										<Grid item xs={12} sm={6} md={6} lg={4} xl={3} key={p.post.id}>
											<PostDetails post={p} updateAction={this.props.updateAction} />
										</Grid>))}
								</Grid>
							</Grid>
						</Grid>
					</DialogContent>
					<Divider />
					<Grid
						style={{ marginTop: '10px', padding: '10px' }}
						container
						spacing={0}
						alignItems='center'
						direction='row'
						justify='flex-start'>
						<Grid item>
							<Typography variant='h5' className={classes.typography}>
								<Switch
									checked={false}
									onChange={this.props.handleChange('autopilot')}
								/>
							</Typography>
						</Grid>
						<Grid item>
							<Grid
								container
								spacing={0}>
								<Grid item xs={12}>
									<Typography variant='h5' className={classes.typography}>
										Turn on Vimma Budget Optimisation for the campaign
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant='caption' className={classes.typography}>
										With Budget Optimisation, Vimma's algorithms allocate the budget based on best performing and fitting creator posts.
									</Typography>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<DialogActions>

						<Button onClick={this.handleClose} disabled={this.context.state.loading}>
							Cancel
						</Button>
						<div className={classes.wrapper}>
							<Button onClick={this.handleAccept} variant="contained" color="primary" disabled={this.context.state.loading}>
								Accept
							</Button>
							{this.context.state.loading && <CircularProgress size={16} className={classes.buttonProgress} />}
						</div>


					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

AcceptPostsDialog.propTypes = {
	fullScreen: PropTypes.bool.isRequired
};

AcceptPostsDialog.contextType = Context;
const AcceptPostsDialogReactive = withMobileDialog()(AcceptPostsDialog);
export default withStyles(styles)(AcceptPostsDialogReactive);